
import { defineComponent } from 'vue'

const FEATURES = [
  { icon: 'check', label: 'Everything included in the Business plan', emphasize: false },
  { icon: 'check', label: 'Full access to the new AI Code Review platform', emphasize: false },
  {
    icon: 'plus',
    label: '$10 per contributor per month complementary AI Review credit',
    emphasize: true
  }
] as const

export default defineComponent({
  name: 'MigrateTeamPlanModal',
  props: {
    currentPriceLabel: {
      type: String,
      required: true
    },
    newPriceLabel: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    features() {
      return FEATURES
    }
  },
  methods: {
    handleClose() {
      if (!this.loading) {
        this.$emit('close')
      }
    }
  }
})
